import { message } from "antd";

import * as API from "../../api";
import * as ActionTypes from "../action-types";

import { setLoadingRemark, unsetLoadingRemark } from "./style";
import { v1_company, v1_employee, v1_employer, v1_payroll } from "./index";

export const get_remark_thru_refid_request = (uid, refid, cb) => (dispatch) => {
  dispatch(setLoadingRemark());

  API.getRemarkThruRefid(uid, refid)
    .then((info) => {
      const { status, msg, remarks } = info;

      if (status === 200) {
        dispatch(get_remark_thru_refid_success(remarks));
        message.success(msg);
      } else {
        message.warning(msg);
      }
    })
    .finally(() => {
      cb();
      dispatch(unsetLoadingRemark());
    });
};

const get_remark_thru_refid_success = (remark) => {
  return {
    type: ActionTypes.GET_REMARK_THRU_REFID,
    remark,
  };
};

export const create_remark_request =
  (items, memid, cb = () => {}) =>
  (dispatch) => {
    dispatch(setLoadingRemark());
    API.createRemark(items)
      .then((info) => {
        const { status, msg, remark, remarkCount } = info;

        if (status === 200) {
          dispatch(create_remark_success(remark));
          if (memid.includes("CO")) {
            dispatch(
              v1_company.update_remarkcount_company_success({
                refid: memid,
                remarkCount,
              })
            );
          } else if (memid.includes("EMP")) {
            dispatch(
              v1_employee.update_remarkcount_employee_success({
                refid: memid,
                remarkCount,
              })
            );
          } else if (memid.includes("EMR")) {
            dispatch(
              v1_employer.update_remarkcount_employer_success({
                refid: memid,
                remarkCount,
              })
            );
          } else if (memid.includes("PR")) {
            dispatch(
              v1_payroll.update_remarkcount_payroll_success({
                refid: memid,
                remarkCount,
              })
            );
          }
          message.success(msg);
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        cb();
        dispatch(unsetLoadingRemark());
      });
  };

const create_remark_success = (remark) => {
  return {
    type: ActionTypes.CREATE_REMARK,
    remark,
  };
};

export const update_remark_request =
  (items, cb = () => {}) =>
  (dispatch) => {
    dispatch(setLoadingRemark());
    API.updateRemark(items)
      .then((info) => {
        const { msg, status, remark } = info;

        if (status === 200) {
          dispatch(update_remark_success(remark));
          message.success(msg);
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        cb();
        dispatch(unsetLoadingRemark());
      });
  };

const update_remark_success = (remark) => {
  return {
    type: ActionTypes.UPDATE_REMARK,
    remark,
  };
};

export const delete_remark_request =
  (remid, memid, cb = () => {}) =>
  (dispatch) => {
    dispatch(setLoadingRemark());
    API.deleteRemark(remid)
      .then((info) => {
        const { msg, status, refid, remarkCount } = info;

        if (status === 200) {
          dispatch(delete_remark_success(remid));
          if (memid.includes("CO")) {
            dispatch(
              v1_company.update_remarkcount_company_success({
                refid: memid,
                remarkCount,
              })
            );
          } else if (memid.includes("EMP")) {
            dispatch(
              v1_employee.update_remarkcount_employee_success({
                refid: memid,
                remarkCount,
              })
            );
          } else if (memid.includes("EMR")) {
            dispatch(
              v1_employer.update_remarkcount_employer_success({
                refid: memid,
                remarkCount,
              })
            );
          } else if (memid.includes("PR")) {
            dispatch(
              v1_payroll.update_remarkcount_payroll_success({
                refid: memid,
                remarkCount,
              })
            );
          }
          message.success(msg);
        } else {
          message.warning(msg);
        }
      })
      .finally(() => {
        cb();
        dispatch(unsetLoadingRemark());
      });
  };

const delete_remark_success = (remid) => {
  return {
    type: ActionTypes.DELETE_REMARK,
    remid,
  };
};

export const close_remark_success = () => {
  return {
    type: ActionTypes.CLOSE_REMARK,
  };
};
